import React from "react";
import KidsVideo from "../../PicesForPages/Kids_Playing_in_park2.mp4";
import FreeConsultation from "../Form/FreeConsultation";
import { Link } from "react-router-dom";

function purchase() {
  return (
    <div className="purchaseParent">
      <div className="purchasetopParent purchasePagetopParent">
        {/* Video element */}
        <video className="background-video" autoPlay loop muted>
          <source src={KidsVideo} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div className="purchasetopBox purchasePagetopBox">
          {/* The existing Purchase span */}
          <span>Purchase</span>
        </div>
      </div>
      <div className="purchaseBottomParent">
        <div className="purchaseBottomBox">
          <div className="purchaseBottomLeftBox">
            <span className="purchaseBottomLeftContent">
              For most people, purchasing a home is one of the largest
              investments they'll ever make. If you're thinking about buying a
              home, you're probably aware of how complex the process can be.
              With so many factors to consider, it's crucial to be
              well-prepared. At Prime Home Mortgage, INC, we are committed to
              helping you find the{" "}
              <span className="purchaseBottomLeftContentBold">
                loan that best suits your unique needs.
              </span>
            </span>
            <span className="purchaseBottomLeftHeader">Getting Started</span>
            <ul className="purchaseBottomLeftUL">
              <li>
                Rent vs. Buy Calculator
                <br />
                <Link
                  to="/renting-versus-buying-calculator"
                  className="purchaseBottomLeftULLink"
                >
                  Click here to compare the costs of renting versus buying.
                </Link>
              </li>
              <li>
                Documents You Will Need
                <br />
                <Link to="/paper-work" className="purchaseBottomLeftULLink">
                  Click here to find out what documents you'll need.
                </Link>
              </li>
              <li>
                Ready to Get Your Loan
                <br />
                <Link to="#" className="purchaseBottomLeftULLink">
                  Click Here to Apply Now
                </Link>
              </li>
            </ul>
            <div className="purchaseBottomLeftButton">
              <Link
                to="https://www.blink.mortgage/app/signup/p/primehomemortgageincorporated/"
                className="purchaseBottomLeftButtonLink"
              >
                APPLY!
              </Link>
            </div>
          </div>
          <FreeConsultation />
        </div>
      </div>
    </div>
  );
}

export default purchase;
